import { render } from "./FloatingButton.vue?vue&type=template&id=03efad55&scoped=true"
import script from "./FloatingButton.vue?vue&type=script&lang=js"
export * from "./FloatingButton.vue?vue&type=script&lang=js"

import "./FloatingButton.vue?vue&type=style&index=0&id=03efad55&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/soilfood.com/soilfood.com/vue/oma-myyja/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03efad55"]])

export default __exports__